module.exports = {
	publicPath: "./",
	devServer: {
		// proxy: "https://api.zaoxiangguan.com"
		proxy: {
			'/apis.map/': {
				target: 'https://apis.map.qq.com/ws/place/v1',
				changeOrigin: true,
				ws: true,
				secure: false
			},
			'/': {
				target: 'https://api.zaoxiangguan.com',
				changeOrigin: true,
				ws: true,
				secure: false
			},
		}
	},
	outputDir: 'dist',

};